/* global femcare */

/**
 * Handles the initialization and management of product sorting within a product listing page.
 */
femcare.product.productSort = {
    /**
     * Initializes sorting functionality, setting initial state and event listeners.
     */
    init: function () {
        this.sortingInitialized = false;
        this.addedReviewsData = false;

        this.initMembers();
        this.initOpenSort();
        this.initSortChangeListener();
    },

    /**
     * Initializes member variables and selects relevant DOM elements for manipulation.
     */
    initMembers: function () {
        this.$productList = $('.product-list');
        this.initSortButton = $('.init-sort');
        this.$sortCloseButton = $('.product-sort__overlay-close');
        this.$sortOptions = $('.product-sort__sort-options');
        this.originalOrder = this.$productList.children('.product-list__item').get();
    },

    /**
     * Sets up event listener for opening the sorting overlay.
     */
    initOpenSort: function () {
        this.initSortButton.click((e) => {
            if (!this.addedReviewsData) {
                this.addReviews();
            }
        });
    },

    /**
     * Fetches and adds review data to product items for sorting. This can be from various sources like Power Reviews or Bazaar Voice.
     */
    addReviews: function () {
        var renderOptions = window.pr_render_options;
        var isBVLoaded = window.$BV;
        // Power Reviews
        if (renderOptions !== undefined) {
            renderOptions.forEach(function (element) {
                var elementId = element.components.CategorySnippet;
                var ratingElement = $('#' + elementId);
                var ratingVal = ratingElement.find('.pr-snippet-rating-decimal').text();
                ratingElement.closest('.product-list__item').attr('data-review', ratingVal);
            });
        } else if (isBVLoaded !== undefined) { // Bazaar Voice
            var productItem = $('.product-list__item');
            productItem.each(function (index, element) {
                var ratingVal = $(element).find('.bv_averageRating_component_container .bv_text').text();
                $(element).attr('data-review', ratingVal);
            });
        }

        this.addedReviewsData = true;
    },

    /**
     * Initializes event listener for change in sorting option.
     */
    initSortChangeListener: function () {
        $('input[name="mandatoryradio"]').on('change',(event) => {
            const sortType = event.target.value;
            this.sortProducts(sortType);
        });
    },

    /**
     * Sorts products based on the selected sort type (e.g., price low to high, price high to low, review low to high, review high to low).
     * Restores original order if the default sort option is selected.
     * @param {string} sortType - The type of sort to perform. This determines the sorting criteria.
     */
    sortProducts: function (sortType) {
        let sortedItems;
        const items = this.$productList.children('.product-list__item').get();
        const productBack = this.$productList.children('.product-list-back').detach();

        switch (sortType) {
            case 'priceLTH':
                sortedItems = items.sort((a, b) => $(a).data('sort-price') - $(b).data('sort-price'));
                break;
            case 'priceHTL':
                sortedItems = items.sort((a, b) => $(b).data('sort-price') - $(a).data('sort-price'));
                break;
            case 'reviewLTH':
                sortedItems = items.sort((a, b) => {
                    const reviewA = a.getAttribute('data-review') || 0;
                    const reviewB = b.getAttribute('data-review') || 0;

                    return parseFloat(reviewA) - parseFloat(reviewB);
                });
                break;
            case 'reviewHTL':
                sortedItems = items.sort((a, b) => {
                    const reviewA = a.getAttribute('data-review') || 0;
                    const reviewB = b.getAttribute('data-review') || 0;

                    return parseFloat(reviewB) - parseFloat(reviewA);
                });
                break;
            default:
                // Attempt to restore the original order without modifying it
                this.$productList.empty().append(this.originalOrder).append(productBack);

                return;
        }

        // This part is reached only if a sort option other than default is selected
        this.$productList.empty().append(sortedItems).append(productBack);
    }
};
